export function sum(numbers: number[]) {
	return (
		numbers.length &&
		numbers.filter((n) => !isNaN(n)).reduce((acc, n) => acc + n)
	);
}
